(function () {
  'use strict';

  // Inline chat page (no floating bubble). Calls chat-origin Tunnel directly with
  // CORS; Pi gates /chat/* on either X-Chat-Worker-Secret OR a trusted Origin header.
  var API = 'https://chat-origin.leosportz.in';
  var LS_VISITOR = 'lsz_visitor_id';
  var LS_SESSION = 'lsz_chat_session_id';
  var LS_SESSION_AT = 'lsz_chat_session_at';
  var COOKIE_VISITOR = 'lsz_visitor_id';

  var widget = document.getElementById('lsz-chat-widget');
  if (!widget) return;

  var messagesEl = document.getElementById('lsz-chat-messages');
  var inputEl = document.getElementById('lsz-chat-input');
  var sendBtn = document.getElementById('lsz-chat-send');
  var emailForm = document.getElementById('lsz-chat-email-form');
  var emailText = document.getElementById('lsz-chat-email-text');
  var emailName = document.getElementById('lsz-chat-email-name');
  var emailInput = document.getElementById('lsz-chat-email-email');
  var emailSubmit = document.getElementById('lsz-chat-email-submit');
  var startForm = document.getElementById('lsz-chat-start-form');
  var startName = document.getElementById('lsz-chat-start-name');
  var startEmail = document.getElementById('lsz-chat-start-email');
  var startSubmit = document.getElementById('lsz-chat-start-submit');
  var startSkip = document.getElementById('lsz-chat-start-skip');
  var inputArea = document.getElementById('lsz-chat-input-area');
  var retryBanner = document.getElementById('lsz-chat-retry');
  var retryBtn = document.getElementById('lsz-chat-retry-btn');

  var welcomeMessage = widget.dataset.welcomeMessage || 'Hi! How can we help you today?';
  var visitorId = getVisitorId();
  var sessionId = getSessionId();
  var es = null;
  var reconnectTimer = null;
  var emailCaptured = false;
  var emailKnown = false;        // do we already have a way to reach this visitor?
  var handoverTimer = null;      // "waiting for a human" → email fallback
  var humanJoined = false;
  var HANDOVER_WAIT_MS = 3 * 60 * 1000;

  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function getVisitorId() {
    var id = localStorage.getItem(LS_VISITOR) || getCookie(COOKIE_VISITOR);
    if (!id) {
      id = uuidv4();
      localStorage.setItem(LS_VISITOR, id);
      setCookie(COOKIE_VISITOR, id, 365);
    }
    return id;
  }

  function getSessionId() {
    var sid = localStorage.getItem(LS_SESSION);
    var at = parseInt(localStorage.getItem(LS_SESSION_AT) || '0', 10);
    if (sid && Date.now() - at < 24 * 60 * 60 * 1000) return sid;
    localStorage.removeItem(LS_SESSION);
    localStorage.removeItem(LS_SESSION_AT);
    return null;
  }

  function setSessionId(sid) {
    sessionId = sid;
    localStorage.setItem(LS_SESSION, sid);
    localStorage.setItem(LS_SESSION_AT, String(Date.now()));
  }

  function historyKey() {
    return 'lsz_chat_history_' + (sessionId || '');
  }

  function saveHistory(msg) {
    if (!sessionId) return;
    var key = historyKey();
    var arr = [];
    try { arr = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) {}
    arr.push(msg);
    localStorage.setItem(key, JSON.stringify(arr));
  }

  function loadHistory() {
    if (!sessionId) return;
    var arr = [];
    try { arr = JSON.parse(localStorage.getItem(historyKey()) || '[]'); } catch (e) {}
    arr.forEach(function (m) { renderMessage(m.sender, m.body, m.time); });
  }

  function formatTime(iso) {
    var d = iso ? new Date(iso) : new Date();
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  function renderMessage(sender, body, time) {
    var div = document.createElement('div');
    div.className = 'lsz-chat-msg lsz-chat-msg--' + sender;
    var t = time || formatTime();
    div.innerHTML = '<div>' + escapeHtml(body) + '</div><span class="lsz-chat-msg-time">' + t + '</span>';
    messagesEl.appendChild(div);
    scrollToBottom();
  }

  function escapeHtml(str) {
    var map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' };
    return String(str).replace(/[&<>"']/g, function (m) { return map[m]; });
  }

  function scrollToBottom() {
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function showRetry() { retryBanner.classList.add('is-visible'); }
  function hideRetry() { retryBanner.classList.remove('is-visible'); }

  function renderStatus(body) {
    var div = document.createElement('div');
    div.className = 'lsz-chat-status-line';
    div.textContent = body;
    messagesEl.appendChild(div);
    scrollToBottom();
  }

  // A human has been requested: reassure, then start the "if no one replies" timer.
  function onHumanRequested() {
    if (humanJoined) return;
    renderStatus('Connecting you to our team — we usually reply within a few minutes.');
    if (handoverTimer) clearTimeout(handoverTimer);
    handoverTimer = setTimeout(onHumanWaitTimeout, HANDOVER_WAIT_MS);
  }

  function onHumanJoined() {
    humanJoined = true;
    if (handoverTimer) { clearTimeout(handoverTimer); handoverTimer = null; }
    renderStatus('You’re now chatting with our team.');
  }

  function onHumanWaitTimeout() {
    handoverTimer = null;
    if (humanJoined) return;
    if (emailKnown) {
      renderStatus('Our team is away right now — we’ll reply to your email shortly.');
    } else {
      renderStatus('Our team is away right now. Leave your email and we’ll get back to you.');
      if (!emailCaptured) { if (emailText) { emailText.textContent = 'Leave your email and we’ll get back to you.'; } emailForm.classList.add('is-visible'); scrollToBottom(); }
    }
  }

  function post(path, body) {
    return fetch(API + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function startChat(name, email) {
    startForm.classList.remove('is-visible');
    if (email) emailKnown = true;
    post('/chat/start', {
      visitorId: visitorId,
      name: name || undefined,
      email: email || undefined,
      pageUrl: location.href,
      userAgent: navigator.userAgent
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        setSessionId(data.sessionId);
        inputArea.style.display = 'flex';
        renderMessage('operator', welcomeMessage);
        saveHistory({ sender: 'operator', body: welcomeMessage, time: formatTime() });
        openStream();
        setTimeout(function () { if (inputEl) inputEl.focus(); }, 100);
      })
      .catch(function () {
        showRetry();
        inputArea.style.display = 'none';
      });
  }

  function sendMessage() {
    var text = inputEl.value.trim();
    if (!text || !sessionId) return;
    inputEl.value = '';
    renderMessage('customer', text);
    saveHistory({ sender: 'customer', body: text, time: formatTime() });
    post('/chat/message', { sessionId: sessionId, text: text })
      .catch(function () { showRetry(); });
  }

  function openStream() {
    if (!sessionId || es) return;
    es = new EventSource(API + '/chat/stream/' + encodeURIComponent(sessionId));
    es.addEventListener('connected', function () { hideRetry(); });
    es.addEventListener('message', function (e) {
      try {
        var data = JSON.parse(e.data);
        if (data.sender && data.body) {
          if (data.sender === 'operator' && !humanJoined) onHumanJoined();
          renderMessage(data.sender, data.body, data.createdAt ? formatTime(data.createdAt) : formatTime());
          saveHistory({ sender: data.sender, body: data.body, time: formatTime(data.createdAt) });
        }
      } catch (_) {}
    });
    es.addEventListener('status', function (e) {
      try {
        var d = JSON.parse(e.data);
        if (d.status === 'human_requested') onHumanRequested();
        else if (d.status === 'human_joined') onHumanJoined();
      } catch (_) {}
    });
    es.addEventListener('idle_prompt', function () {
      inputArea.style.display = 'none';
      emailForm.classList.add('is-visible');
    });
    es.addEventListener('request_email', function () {
      // Soft ask on handover: show the email form but keep the chat usable.
      if (emailCaptured || emailForm.classList.contains('is-visible')) return;
      if (emailText) {
        emailText.textContent = "Our team isn't online right now. Leave your email and we'll get back to you soon.";
      }
      emailForm.classList.add('is-visible');
      scrollToBottom();
    });
    es.addEventListener('closed', function () { closeStream(); });
    es.onerror = function () {
      showRetry();
      closeStream();
      reconnectTimer = setTimeout(openStream, 3000);
    };
  }

  function closeStream() {
    if (reconnectTimer) { clearTimeout(reconnectTimer); reconnectTimer = null; }
    if (es) { es.close(); es = null; }
  }

  function submitEmail() {
    var email = emailInput.value.trim();
    if (!email || !sessionId) return;
    var name = emailName.value.trim() || undefined;
    post('/chat/email', { sessionId: sessionId, email: email, name: name })
      .then(function () {
        emailCaptured = true;
        emailKnown = true;
        emailForm.classList.remove('is-visible');
        renderMessage('operator', 'Thanks! We\'ll reach out to you soon.');
        saveHistory({ sender: 'operator', body: "Thanks! We'll reach out to you soon.", time: formatTime() });
      })
      .catch(function () { showRetry(); });
  }

  sendBtn.addEventListener('click', sendMessage);
  inputEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') sendMessage(); });
  retryBtn.addEventListener('click', function () { hideRetry(); if (sessionId) openStream(); });

  startSubmit.addEventListener('click', function () {
    startChat(startName.value.trim(), startEmail.value.trim());
  });
  startSkip.addEventListener('click', function () {
    startChat(null, null);
  });
  emailSubmit.addEventListener('click', submitEmail);

  if (sessionId) {
    inputArea.style.display = 'flex';
    loadHistory();
    openStream();
    setTimeout(function () { if (inputEl) inputEl.focus(); }, 100);
  } else {
    // Show the pre-chat form (optional email) so the chat opens like a real support desk.
    inputArea.style.display = 'none';
    startForm.classList.add('is-visible');
    setTimeout(function () { if (startEmail) startEmail.focus(); }, 100);
  }
})();
